import { useCallback } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const GSC_BASE_PATH = '/google-search-console';
const ACCOUNT_URI = `${GSC_BASE_PATH}/account`;
const updateGoogleSearchConsoleAccount = args => {
  return http.post(ACCOUNT_URI, {
    data: {
      email: args.email
    }
  });
};
const UPDATE_ACCOUNT = registerMutation({
  fieldName: 'googleSearchConsoleUpdateAccount',
  args: ['email'],
  fetcher: updateGoogleSearchConsoleAccount
});
export const useUpdateGoogleSearchConsoleAccount = () => {
  const [update, {
    loading,
    error
  }] = useMutation(UPDATE_ACCOUNT);
  const updateAccount = useCallback(email => {
    return update({
      variables: {
        email
      }
    });
  }, [update]);
  return {
    updateAccount,
    updating: loading,
    error
  };
};